<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>
<style lang="less" scoped>
.content {
  padding: 20px;
}
</style>
